import { PostType } from '../../../../models/post-overview';
import { StringUtils } from '../../../utils/string.utils';
var PostTypeDisplayComponent = /** @class */ (function () {
    function PostTypeDisplayComponent() {
    }
    Object.defineProperty(PostTypeDisplayComponent.prototype, "postType", {
        get: function () {
            return this._postType;
        },
        set: function (value) {
            this._postType = value;
            this.hasValue = !StringUtils.isUndefinedNullOrEmpty(value);
        },
        enumerable: true,
        configurable: true
    });
    return PostTypeDisplayComponent;
}());
export { PostTypeDisplayComponent };



// WEBPACK FOOTER //
// ./src/app/main/post-overview/post-type-display/post-type-display.component.ts.pre-build-optimizer.js